// @flow
import { dndOverlaySetDndState } from 'actions/dndOverlay';

export const DRAW_OVERLAY_TOGGLE_DRAW_MODE = 'drawOverlay/TOGGLE_DRAW_MODE';
export const DRAW_OVERLAY_CLEAR = 'drawOverlay/CLEAR';
export const DRAW_OVERLAY_SET_FEATURE = 'drawOverlay/SET_FEATURE';
export const DRAW_OVERLAY_SET_MODE = 'drawOverlay/SET_MODE';

export function toggleDrawMode(appInDrawMode) {
  return {
    type: DRAW_OVERLAY_TOGGLE_DRAW_MODE,
    appInDrawMode,
  };
}

export function clear() {
  return dispatch => {
    dispatch(dndOverlaySetDndState(null));
    dispatch({ type: DRAW_OVERLAY_CLEAR });
  };
}

export function drawingFinished(feature) {
  return dispatch => {
    dispatch({
      type: DRAW_OVERLAY_SET_FEATURE,
      feature,
    });

    dispatch({
      type: DRAW_OVERLAY_SET_MODE,
      mode: 'simple_select',
    });
  };
}

export function setMode(mode) {
  return dispatch => {
    if (mode !== 'simple_select') {
      dispatch({
        type: DRAW_OVERLAY_CLEAR,
      });
      dispatch(dndOverlaySetDndState(null));
    }

    dispatch({
      type: DRAW_OVERLAY_SET_MODE,
      mode,
    });
  };
}



// WEBPACK FOOTER //
// ./actions/drawOverlay.js